import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { AuthLoginData } from '../interfaces/auth-login-data';
import { LoginData } from '../interfaces/login-data';
import { LoginConfirm } from '../interfaces/login-confirm';
import { Subscriber } from '../interfaces/subscriber';
import { Unsubscribe } from '../interfaces/unsubscribe';
import { userLogout } from '../interfaces/userLogout';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DigimatrixService {
  constructor(private http: HttpClient) { }

  authLogin() {
    return this.http.post<AuthLoginData>(environment.apiUrl + "/api/checkout/protectedScript", {
      // email : "api-hedaya@digimatrix.ly",
      // password : "H@d89#&y"
    }).pipe(
      catchError((error) => {
        // console.error('Error:', error);
        return this.handleError(error);
      }),
      tap(resData => {
        // console.log('Response Data:', resData);
        localStorage.setItem('transaction_identify', resData?.data?.transaction_identify);
        this.loadScript(resData?.data?.dcbprotect);
        this.handleReqeust(resData?.data?.messageCode, resData?.data);
      })
    );
  }

  login(phone: string, uuid: string) {
    return this.http.post<LoginData>(environment.apiUrl + "/api/checkout/login", {
      phone: phone,
      transaction_identify: localStorage.getItem('transaction_identify'),
      uuid: uuid,
      platform: localStorage.getItem('platform')
    }).pipe(
      catchError((error) => {
        // console.error('Error:', error);
        return this.handleError(error.message);
      }),
      tap(resData => {

        // console.log('Response Data:', resData);
      })
    );
  }

  loginConfirm(otp: number, phone: string, uuid: string) {
    return this.http.post<LoginConfirm>(environment.apiUrl + "/api/checkout/confirm-login", {
      phone: phone,
      transaction_identify: localStorage.getItem('transaction_identify'),
      otp: otp,
      uuid: uuid,
      platform: localStorage.getItem('platform')
    }).pipe(
      catchError((error) => {
        // console.error('Error:', error);
        return this.handleError(error.message);
      }),
      tap(resData => {
        console.log('Response Data:', resData);

        // console.log('Response Data:', resData);
      })
    );
  }

  unsubscribe(phone: string | null = null) {
    return this.http.post<Unsubscribe>(environment.apiUrl + "/api/checkout/unsubscribe", {
      phone: phone
    }).pipe(
      catchError((error) => {
        // console.error('Error:', error);
        return this.handleError(error.message);
      }),
      tap(resData => {
        console.log('Response Data:', resData);

        // console.log('Response Data:', resData);
      })
    );
  }

  unsubscribeConfirm(otp: number, phone: string) {
    return this.http.post<LoginConfirm>(environment.apiUrl + "/api/checkout/unsubscribe-confirm", {
      phone: phone,
      otp: otp,
      platform: localStorage.getItem('platform')
    }).pipe(
      catchError((error) => {
        // console.error('Error:', error);
        return this.handleError(error.message);
      }),
      tap(resData => {

        // console.log('Response Data:', resData);
      })
    );
  }

  logoutUserOnUnsubscribe(phone: string | null = null) {
    return this.http.post<userLogout>(environment.apiUrl + "/api/checkout/logout-user-on-unsubscribe", {
      phone: phone
    }).pipe(
      catchError((error) => {
        return this.handleError(error.message);
      }),
      tap(resData => {
        console.log('Response Data:', resData.message);
      })
    );
  }

  subscriberDetails(phone: string | null = null) {
    return this.http.get<Subscriber>(environment.apiUrl + "/api/checkout/subscriber-details?phone=" + phone).pipe(
      catchError((error) => {
        // console.error('Error:', error);
        return this.handleError(error.message);
      }),
      tap(resData => {

        // console.log('Response Data:', resData);
      })
    );
  }

  private handleError(httpError: HttpErrorResponse) {
    return throwError(httpError.message || "An unexpected error occurred");
  }

  public handleReqeust(code: string, data: object) {
    return data;
  }

  private loadScript(scriptContent: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = scriptContent;  // Use the response data as script content
    document.head.appendChild(script); // Append the script tag to the <head> section of index.html

    // Dispatch event after script is appended
    const ev = new Event('DCBProtectRun');
    document.dispatchEvent(ev);
  }

  resendPassword(phoneNumber: string): Observable<any> {
    return this.http.post(environment.apiUrl + "/api/checkout/send-sms-template", { phone: phoneNumber })
  }
}
